import TenderEvalTable from './TenderEvalTable';

const ProductHydro = ({ refreshTrigger }) => (
  <TenderEvalTable procurementTypeHeader='1' refreshTrigger={refreshTrigger} />
);

export default ProductHydro;
